import React from "react";
import { useTheme } from "../../context/ThemeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faAngleRight,
    faGear,
    faCheckDouble,
    faShieldHalved,
    faCookieBite,
    faCircleExclamation,
    faRotate,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { Outlet } from "react-router-dom";
import HeaderSection from "../../components/HeaderSection/HeaderSection";
import BottomSection from "../../components/BottomSection/BottomSection";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

// Style
import "../../assets/PoliciesTermsToolAssets/App.css";

const TermsFeedPage = () => {
         useTheme();
    
    const navigate = useNavigate();

    const cardData = [
        {
            title: "Privacy Policy Generator",
            id: "privacy-policy",
            icon: faShieldHalved,
        },
        {
            title: "Terms & Conditions Generator",
            id: "terms-and-conditions",
            icon: faCheckDouble,
        },
        {
            title: "Cookies Policy Generator",
            id: "cookies-policy",
            icon: faCookieBite,
        },
        // { title: "Cookie Consent", id: "cookie-consent", icon: faLock },
        { title: "EULA Generator", id: "eula", icon: faGear },
        {
            title: "Disclaimer Generator",
            id: "disclaimer",
            icon: faCircleExclamation,
        },
        {
            title: "Return & Refund Policy Generator",
            id: "return-and-refund-policy",
            icon: faRotate,
        },
    ];

    const handleCardClick = (id) => {
        console.log(id);
        navigate(`/form/${id}`);
    };

    return (
        <>
            <HeaderSection toolId="policiesTerm" />
            <div className="max-w-4xl mx-auto p-4  lg:max-w-full lg:px-4">
                <section className="bg-white dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 dark:bg-gray-800 rounded-xl shadow-sm dark:shadow-gray-900/10 dark:shadow-gray-900/10 dark:shadow-gray-900/10 dark:shadow-gray-900/10 dark:shadow-gray-900/10 dark:shadow-gray-900/10 border border-gray-200 dark:border-gray-700 dark:border-gray-700 dark:border-gray-700 dark:border-gray-700 dark:border-gray-700 dark:border-gray-700 overflow-hidden">
                    <div className="bg-gradient-to-r from-green-500 to-green-600 p-6 text-white">
                        <h1 className="text-2xl font-bold mb-2 flex items-center">
                            <FontAwesomeIcon
                                icon={faEnvelope}
                                className="mr-3"
                            />
                            TermsFeed
                        </h1>
                        <p className="opacity-90">
                            Generate terms and conditions in real-time with
                            comprehensive validation checks
                        </p>
                    </div>
                    <div className="container">
                        <div className="cards-main">
                            <div className="card-main-top">
                                {cardData.slice(0, 1).map((card) => (
                                    <div
                                        key={card.id}
                                        id={card.id}
                                        className="card"
                                        onClick={() => handleCardClick(card.id)}
                                    >
                                        <FontAwesomeIcon icon={card.icon} />
                                        <h3>{card.title}</h3>
                                        <div className="start-up">
                                            <p>Start</p>
                                            <FontAwesomeIcon
                                                icon={faAngleRight}
                                            />
                                        </div>
                                    </div>
                                ))}
                                <div className="column-container">
                                    {cardData.slice(1, 3).map((card) => (
                                        <div
                                            key={card.id}
                                            id={card.id}
                                            className="card"
                                            onClick={() =>
                                                handleCardClick(card.id)
                                            }
                                        >
                                            <FontAwesomeIcon icon={card.icon} />
                                            <h3>{card.title}</h3>
                                            <div className="start-up">
                                                <p>Start</p>
                                                <FontAwesomeIcon
                                                    icon={faAngleRight}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="card-main-bottom">
                                {cardData.slice(3).map((card) => (
                                    <div
                                        key={card.id}
                                        id={card.id}
                                        className="card"
                                        onClick={() => handleCardClick(card.id)}
                                    >
                                        <FontAwesomeIcon icon={card.icon} />
                                        <h3>{card.title}</h3>
                                        <div className="start-up">
                                            <p>Start</p>
                                            <FontAwesomeIcon
                                                icon={faAngleRight}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <Outlet />
                </section>
            </div>
            <BottomSection toolId="policiesTerm" />
        </>
    );
};

export default TermsFeedPage;
